import type { ListColumn } from "../../../../../../../shared/frontend/list/listColumn";
import { Tag } from "../../../../../../../shared/frontend/ui";
import type { I18nContextValue } from "../../../app/i18n/useI18n";
import { formatDateTimeIso } from "../../../app/units/format";
import type { UnitsSettings } from "../../../app/units/units";
import type { ColumnDefinition } from "../../../app/utils/useProTableColumnEditor";
import { accessMediumTypeLabel } from "./personAccessMediumUtils";
import type { AccessMediumRow } from "./personDetailTypes";

const TYPE_COLUMN_WIDTH = 110;
const IS_ACTIVE_COLUMN_WIDTH = 120;
const CREATED_AT_COLUMN_WIDTH = 220;

export const PERSON_ACCESS_MEDIA_COLUMN_DEFINITIONS: ColumnDefinition[] = [
  { key: "type", label: "Type", defaultVisible: true },
  { key: "mediumId", label: "Medium ID", defaultVisible: true },
  { key: "isActive", label: "Status", defaultVisible: true },
  { key: "createdAt", label: "Created", defaultVisible: true },
];

export function createPersonAccessMediaColumns(
  text: I18nContextValue["text"],
  units: UnitsSettings
): Record<string, ListColumn<AccessMediumRow>> {
  return {
    type: {
      title: text("Type"),
      dataIndex: "type",
      key: "type",
      width: TYPE_COLUMN_WIDTH,
      render: (_: unknown, row: AccessMediumRow) => accessMediumTypeLabel(row.type, text)
    },
    mediumId: {
      title: text("Medium ID"),
      dataIndex: "mediumId",
      key: "mediumId",
    },
    isActive: {
      title: text("Status"),
      dataIndex: "isActive",
      key: "isActive",
      width: IS_ACTIVE_COLUMN_WIDTH,
      render: (_: unknown, row: AccessMediumRow) =>
        row.isActive ? <Tag color="green">{text("Active")}</Tag> : <Tag>{text("Inactive")}</Tag>
    },
    createdAt: {
      title: text("Created"),
      dataIndex: "createdAt",
      key: "createdAt",
      width: CREATED_AT_COLUMN_WIDTH,
      render: (_: unknown, row: AccessMediumRow) => (row.createdAt ? formatDateTimeIso(row.createdAt, units) : "")
    },
  };
}
